import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { editUserTrackingWalletRequestAction } from './wallet-tracker-requests'

import type { EditTrackingWalletPayload } from './wallet-tracker-requests'
import type { WalletAddress } from '@root/entities/wallet/model/WalletAddress'
import type { TrackingWallet } from '@root/entities/wallet-tracking'

interface EditTrackingWalletFormPayload
  extends Omit<EditTrackingWalletPayload, 'walletAddress'> {}

export const reatomEditTrackingWalletForm = (args: {
  walletAddress: WalletAddress
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: editUserTrackingWalletRequestAction,
    prepare: (_, value: EditTrackingWalletFormPayload) => ({
      walletAddress: args.walletAddress,
      ...value,
    }),
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      walletTrackingUpdatedEvent(ctx, { updatedTrackingWallet: result.success })
      showSnackbarAction(ctx, {
        text: i18next.t('wallet-tracker.edit-wallet.success'),
        intent: 'success',
      })
    },
    concurrently: true,
  })

  return requestState
}

// eslint-disable-next-line @reatom/unit-naming-rule
export const walletTrackingUpdatedEvent = action<{
  updatedTrackingWallet: TrackingWallet.TrackingWallet
}>('walletTrackingUpdatedEvent')

export const reatomToggleWalletAlert = ({
  walletAddress,
}: {
  walletAddress: WalletAddress
}) => {
  const theAtom = reatomRequest({
    execAction: editUserTrackingWalletRequestAction,
    prepare: (_, enabled: boolean) => ({
      walletAddress: walletAddress,
      alertsEnabled: enabled,
    }),
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      walletTrackingUpdatedEvent(ctx, { updatedTrackingWallet: result.success })
    },
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'toggle-wallet-alert',
  })

  return theAtom
}
